var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShippingmanagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6366 16.458C18.8294 16.458 17.3593 17.9282 17.3593 19.7353C17.3593 21.5425 18.8294 23.0126 20.6366 23.0126C22.444 23.0126 23.9139 21.5425 23.9139 19.7353C23.9139 17.9282 22.4437 16.458 20.6366 16.458ZM20.6366 21.374C19.7329 21.374 18.9979 20.639 18.9979 19.7353C18.9979 18.8316 19.7329 18.0967 20.6366 18.0967C21.5403 18.0967 22.2752 18.8316 22.2752 19.7353C22.2752 20.6391 21.5403 21.374 20.6366 21.374Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43906 16.458C7.63191 16.458 6.16174 17.9282 6.16174 19.7353C6.16174 21.5425 7.63191 23.0126 9.43906 23.0126C11.2462 23.0126 12.7164 21.5425 12.7164 19.7353C12.7164 17.9282 11.2462 16.458 9.43906 16.458ZM9.43906 21.374C8.53536 21.374 7.8004 20.639 7.8004 19.7353C7.8004 18.8316 8.53536 18.0967 9.43906 18.0967C10.3425 18.0967 11.0777 18.8316 11.0777 19.7353C11.0777 20.6391 10.3428 21.374 9.43906 21.374Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8435 7.07717C22.7042 6.80051 22.421 6.62598 22.1113 6.62598H17.7961V8.26464H21.606L23.837 12.7021L25.3015 11.9658L22.8435 7.07717Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1786 18.9434H11.979V20.582H18.1786V18.9434Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98101 18.9434H4.14072C3.68815 18.9434 3.32141 19.3102 3.32141 19.7627C3.32141 20.2152 3.6882 20.582 4.14072 20.582H6.98106C7.43363 20.582 7.80037 20.2152 7.80037 19.7627C7.80037 19.3101 7.43357 18.9434 6.98101 18.9434Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8279 13.9344L25.2163 11.8587C25.0615 11.6588 24.8225 11.5419 24.5693 11.5419H18.6155V5.80661C18.6155 5.35405 18.2487 4.9873 17.7962 4.9873H4.14072C3.68815 4.9873 3.32141 5.3541 3.32141 5.80661C3.32141 6.25912 3.6882 6.62591 4.14072 6.62591H16.9768V12.3612C16.9768 12.8138 17.3436 13.1805 17.7962 13.1805H24.1681L25.3613 14.7176V18.9431H23.0945C22.6419 18.9431 22.2752 19.3099 22.2752 19.7624C22.2752 20.215 22.642 20.5817 23.0945 20.5817H26.1806C26.6332 20.5817 26.9999 20.2149 26.9999 19.7624V14.4369C26.9999 14.255 26.9393 14.078 26.8279 13.9344Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92649 14.792H3.15756C2.705 14.792 2.33826 15.1588 2.33826 15.6113C2.33826 16.0639 2.70505 16.4306 3.15756 16.4306H6.92644C7.37901 16.4306 7.74575 16.0638 7.74575 15.6113C7.7458 15.1588 7.37901 14.792 6.92649 14.792Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81092 11.5693H1.8193C1.36679 11.5693 1 11.9361 1 12.3887C1 12.8413 1.36679 13.208 1.8193 13.208H8.81092C9.26348 13.208 9.63022 12.8412 9.63022 12.3887C9.63022 11.9362 9.26348 11.5693 8.81092 11.5693Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1492 8.34668H3.15756C2.705 8.34668 2.33826 8.71347 2.33826 9.16598C2.33826 9.61855 2.70505 9.98529 3.15756 9.98529H10.1492C10.6017 9.98529 10.9685 9.6185 10.9685 9.16598C10.9685 8.71347 10.6017 8.34668 10.1492 8.34668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingmanagement);
export default __webpack_public_path__ + "static/media/Shippingmanagement.ff7b2a24f352200d979368ab94ca5f63.svg";
export { ForwardRef as ReactComponent };